module.exports = __webpack_public_path__ + "img/产品服务1.86d0707c.png";